import { render, staticRenderFns } from "./FeDeleteButton.vue?vue&type=template&id=527ab3b2&"
import script from "./FeDeleteButton.vue?vue&type=script&lang=js&"
export * from "./FeDeleteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports